<template>
  <div class='pptDetail'>
    <section class="section detail-section centerbox columnbox ppt-detail">
      <div class="content centerbox columnbox w1200">
        <div class="route-links flexbox">
          <a class="border-r" @click="goResearchInstitute(0)">微创创新研究院</a>
          <a class="border-r" @click="goResearchInstitute(1)">PPT课件</a>
          <a class="current">{{ content.current }}</a>
        </div>
        <div class="ppt-preview centerbox">
          <iframe class="preview-iframe" :src="content.pptUrl"></iframe>
        </div>
        <div class="ppt-down betweenbox">
          <a class="return-a centerbox" @click="backList()"><img src="../../assets/images/r-ico.png"> 返回列表</a>
          <h3>PPT课件：{{ content.title }}</h3>
          <a  :href="content.download" class="down-button centerbox">&ensp;立即下载</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  metaInfo() {
    return {
      title: "PPT详情-健新",
      meta: [
        { name: "keywords", content: "keyword1, keyword2, keyword3" },
        { name: "description", content: "Page description" },
      ],
    };
  },
  mounted() {

  },
  data() {
    return {
      content:{}
    }
  },
  created() {
    let data = {
        Title: this.$route.query.title,
        ForumTypeCode: "YCPPT",
      };
    this.getPPTList(data)
  },
  // 监听导航下拉回收
  watch: {
  },
  methods: {
    getPPTList(data) {
      axios
        .post("api/Forum/GetDoc", { ...data })
        .then((res) => {
          if (res) {
           this.content = JSON.parse(res.data.OutputData.Content)
          } else {
            this.$message({
              type: "error",
              message: "请求数据失败",
            });
          }
        });
    },
    // 微创创新研究院
    goResearchInstitute(index) {
       ('跳转')
      this.$router.push({ path: '/researchInstitute', query: { index: index } })
    },
    goStudyDetail() {

    },
      // 返回列表
      backList() {
      this.$router.push({
        name:"jxResearchInstitute",
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/base.less";

.pptDetail {
  width: 100%;
  color: #333;
  line-height: 1.7;
  .section {
    .w1200 {
      height: auto;
    }
    .content {
      div {
        text-align: left;
      }
      .route-links {
        a {
          color: #8d8d8d;
          line-height: 1.2;
        }
        .border-r {
          border-right: 1PX solid #333;
        }
        a:nth-child(1) {
          padding-left: 0;
        }
      }
      .ppt-preview {
        margin-top: 0;
        overflow-x: hidden;
        // border: 1px solid #D2D2D2;
        iframe {
          width: 100%;
          height: 100%;
          overflow-x: hidden;
        }
      }
      .ppt-down {
        border: 1px solid #D2D2D2;
        h3 {
          color: #333;
        }
        .down-button {
          background: #007edd;
          color: #fff;
        }
        .down-button:before {
          content: "";
          background: url(../../assets/images/ppt-down.png) center center no-repeat;
          background-size: cover;
        }
      }
    }
  }


  @media only screen and (min-width: 960px) {
    .section {
      .content {
        padding-top: 130PX;
        .route-links,
        .ppt-preview,
        .ppt-down {
          width: 100%;
          margin: 20PX auto;
        }
        // .ppt-preview,
        .ppt-down {
          border: 1PX solid #D2D2D2;
          padding: 10PX;
        }
        .route-links {
          a {
            font-size: 14PX;
            padding-left: 15PX;
            padding-right: 15PX;
            white-space: nowrap;
          }
        }
        .ppt-preview {
          width: 100%;
          height: 700PX;
        }
        .ppt-down {
          width: 100%;
          margin: 20PX auto;
          h3 {
            font-size: 18PX;
          }
          .down-button {
            width: 188PX;
            height: 60PX;
            font-size: 20PX;
          }
          .down-button:before {
            width: 27PX;
            height: 27PX;
          }
        }
      }
    }
  }
  @media screen and (max-width:959px) and (min-width:320px) {
    .section {
      .content {
        padding-top: 3.52rem;
        .route-links,
        .ppt-preview,
        .ppt-down {
          width: 100%;
          margin: 0.8rem auto;
        }
        .ppt-preview,
        .ppt-down {
          padding: 0.4rem;
        }
        .route-links {
          a {
            font-size: 0.96rem;
            padding-left: 0.8rem;
            padding-right: 0.8rem;
            white-space: nowrap;
          }
          a.current {
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .ppt-preview {
          height: 15.92rem;
        }
        .ppt-down {
          -moz-box-lines: multiple;
          -webkit-box-lines: multiple;
          box-lines: multiple;
          flex-wrap: wrap;
          -webkit-flex-wrap: wrap;
          -moz-flex-wrap: wrap;
          h3 {
            font-size: .96rem;
            margin-bottom: .96rem;
          }
          .down-button {
            width: 9.6rem;
            height: 2.4rem;
            font-size: 0.96rem;
          }
          .down-button:before {
            width: 1.12rem;
            height: 1.12rem;
          }
        }
      }
    }
  }
}
</style>